// BLUE
import blue1 from '../asset/projects/blue/blue1.png';
import blue2 from '../asset/projects/blue/blue2.png';
import blue3 from '../asset/projects/blue/blue3.png';
import blue4 from '../asset/projects/blue/blue4.png';


// 3CLICK
import click1 from '../asset/projects/3click/3click1.png';
import click2 from '../asset/projects/3click/3click2.png';
import click3 from '../asset/projects/3click/3click3.png';
import click4 from '../asset/projects/3click/3click4.png';


// CHATR
import chatr1 from '../asset/projects/chatr/chatr1.png';
import chatr2 from '../asset/projects/chatr/chatr2.png';
import chatr3 from '../asset/projects/chatr/chatr3.png';
import chatr4 from '../asset/projects/chatr/chatr4.png';


// DARZI
import darzi1 from '../asset/projects/darzi/darzi1.png';
import darzi2 from '../asset/projects/darzi/darzi2.png';
import darzi3 from '../asset/projects/darzi/darzi3.png';
import darzi4 from '../asset/projects/darzi/darzi4.png';


// TIPAX
import tipax1 from '../asset/projects/tipax/tipax1.png';
import tipax2 from '../asset/projects/tipax/tipax2.png';
import tipax3 from '../asset/projects/tipax/tipax3.png';
import tipax4 from '../asset/projects/tipax/tipax4.png';


// YAHOO
import yahoo1 from '../asset/projects/yahoo/yahoo1.png';
import yahoo2 from '../asset/projects/yahoo/yahoo2.png';
import yahoo3 from '../asset/projects/yahoo/yahoo3.png';
import yahoo4 from '../asset/projects/yahoo/yahoo4.png';


// CITYNET
import citynet1 from '../asset/projects/citynet/citynet1.png';
import citynet2 from '../asset/projects/citynet/citynet2.png';
import citynet3 from '../asset/projects/citynet/citynet3.png';
import citynet4 from '../asset/projects/citynet/citynet4.png';


const projectImages = {
    blue: [
        blue1,
        blue2,
        blue3,
        blue4
    ],

    "3click": [
        click1,
        click2,
        click3,
        click4
    ],

    chatr: [
        chatr1,
        chatr2,
        chatr3,
        chatr4
    ],

    darzi: [
        darzi1,
        darzi2,
        darzi3,
        darzi4
    ],

    tipax: [
        tipax1,
        tipax2,
        tipax3,
        tipax4
    ],

    yahoo: [
        yahoo1,
        yahoo2,
        yahoo3,
        yahoo4
    ],

    citynet: [
        citynet1,
        citynet2,
        citynet3,
        citynet4
    ]
};


export default projectImages;